module.exports = __webpack_public_path__ + "static/media/300px-Leica_IIIg_img_1881.d514fd0d.jpg";